import styled from "styled-components";

export const MobileViewContainer = styled.div`
  padding: 0 12px;
  display: none;
  @media (max-width: 560px) {
    display: block;
  }
`;

export const Heading = styled.div`
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  img {
    width: 46px;
  }
  h2 {
    font-size: 27px;
    color: #00446e;
    font-family: "latobold";
  }
`;

export const AccordionContainer = styled.div`
  .download-wrapper {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 6px 0;
  }
  .downloadable {
    display: flex;
    align-items: center;
    gap: 3px;
    /* span {
      font-size: 12px;
    } */
    svg {
      height: 17px;
      width: 20px;
      color: #61b01f;
    }
  }
  .MuiAccordion-root {
    border-radius: 4px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    margin-bottom: 8px;
  }
  .MuiAccordion-root.Mui-expanded {
    margin: 8px 0 !important;
  }
  .MuiAccordionSummary-content {
    margin: 10px 0;
  }
  .MuiAccordionSummary-root {
    padding: 0 15px;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 10px 0;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 51px;
  }
  .MuiAccordionSummary-content {
    .accordion-header {
      display: grid;
      flex: 1;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 4px;
      h3 {
        color: #000;
        font-size: 17px;
        font-family: "latobold";
        display: flex;
        align-items: center;
        gap: 6px;
        word-break: break-word;
        :last-child {
          justify-content: flex-end;
          text-align: right;
        }
      }

      p {
        font-size: 10px;
        font-family: "latobold";
        color: #00000087;
        min-width: 64px;
        text-align: right;
      }
      &.green-bid-status {
        color: #44a019;
      }
    }
  }

  .MuiAccordionDetails-root {
    padding: 0px 15px 8px;
    .accordion-detail-section {
      width: 100%;
      .text-section {
        display: flex;
        flex-direction: column;
        gap: 6px;
        border-bottom: solid 1px #7070704d;
        padding-bottom: 9px;
        > div {
          display: grid;
          align-items: center;
          grid-template-columns: 1fr 1fr;
          gap: 6px;
          flex: 1;
          p {
            font-size: 17px;

            margin: 0;
            &.label-text {
              font-family: "latobold";
              width: 100%;
            }
          }
        }
      }
      .action-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 8px;
        button {
          border-radius: 2px;
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
          background-color: #44a019;
          height: 19px;
          color: #fff;
          font-size: 10px;
          font-family: "latobold";
          border: none;
        }
      }
    }
  }
  @media (max-width: 370px) {
    .MuiAccordionSummary-content {
      .accordion-header {
        h3 {
          font-size: 15px;
        }
      }
    }
    .MuiAccordionDetails-root {
      .accordion-detail-section {
        .text-section {
          > div {
            p {
              font-size: 15px;
            }
          }
        }
      }
    }
  }
  @media (max-width: 340px) {
    .MuiAccordionSummary-content {
      .accordion-header {
        h3 {
          font-size: 14px;
        }
      }
    }
    .MuiAccordionDetails-root {
      .accordion-detail-section {
        .text-section {
          > div {
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
`;
